import React, { Component } from 'react';

import { List, ListItem } from 'material-ui/List';
import subha from '../../images/subhadatta.jpg'
import locationimg from '../../images/location.svg'
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import defaultImage from '../../images/default.gif'

import {
    Link, withRouter
} from 'react-router-dom';
import * as actions from '../../actions/actions.jsx'

import { connect } from 'react-redux'

const mapStateToProps = state =>
    ({
        profileState: state.getProfileReducer.profileState,
        display: state.getProfileReducer.display,
        optionState: state.selectedTabReducer.selectedTabReducer,

    })

const mapDispatchToProps = dispatch =>
    ({
        fetchProfileState() {
            dispatch(
                actions.getProfileAction()
            )
        },
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        clearInput() {
            dispatch(
                actions.clearInputAction()
            )
        },
        clearProfile(){
            dispatch(
                actions.clearProfileAction()
            )
        }
    })

class LeftLink extends Component {
    constructor(props) {
        super(props);
        selectedOption: ''
        mediaInfo:''
        
    }
    componentDidMount() {
      
        let _this = this
        this.props.fetchProfileState()
        this.props.fetchSelectedTab(localStorage.getItem("taboption"))
        // this.setState({
        //     selectedOption:localStorage.getItem('taboption')
        // },()=>{
        //     localStorage.setItem("taboption",_this.state.selectedOption)
        //     _this.props.fetchSelectedTab(_this.state.selectedOption)
        // })
    }
    componentWillMount(){
        const notProfile= localStorage.setItem("comp","othercomp")
    }

    handleProfile(e) {
        let _this = this
        const { profileState } = this.props
        if (localStorage.getItem("comp") === "profilecomp") {
            this.setState({
                selectedOption: "tab1"
            }, () => {
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.callBackFromParent()
            })
        }
        else {
            this.setState({
                selectedOption: "tab1"
            }, () => {
                localStorage.setItem("taboption", "tab3")
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

            })
        }

    }
    handleCards(e) {
        this.props.history.push("/upgrade-my-card")
    }
    handleAlerts(e) {
        let _this = this;
        const { profileState } = this.props
        if (localStorage.getItem("comp") === "profilecomp") {
            this.setState({
                selectedOption: "tab3"
            }, () => {
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.callBackFromParent()
            })
        }
        else {
            this.setState({
                selectedOption: "tab3"
            }, () => {
                localStorage.setItem("taboption", "tab3")
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

            })
        }


    }
    handleLoadcard(e) {
        this.props.history.push("/loadcard")
    }
    handleFriends(e) {
        this.props.history.push("/friends&family")
    }
    handleLogout(e) {
        localStorage.clear();
        this.props.clearInput()
        this.props.clearProfile()
        this.props.history.push("/logout" )
        
    }
    
    
    render() {
        const { profileState } = this.props
        //const {mediaInfo}=this.state
        return (
            <div>
                {profileState.status === 200 ?
                    <figure className="snip1344">
                        <img src={subha} alt="profile-sample1" className="background" />
                        {profileState.body.profilePicture !== null?
                        <Link to="/manage-my-profile">
                            <img src={"data:image/jpeg;base64,"+ profileState.body.profilePicture.mediaInfo || defaultImage} alt="profile-sample1" className="profile" /></Link>:<img src={ defaultImage} alt="profile-sample1" className="profile" />}
                        <figcaption>
                            <h4>{(profileState.body.firstName !== "" && profileState.body.firstName!== null)? profileState.body.firstName + " " + profileState.body.lastName : ""}<span><img src={locationimg} alt="" />{profileState.body.city}</span></h4>
                        </figcaption>
                    </figure>
                    : <div></div>
                }
                <div className="dashboard-links">
                    <h3>Quick Links</h3>
                    <div className="row" >
                        {/* <MobileTearSheet> */}
                        <List style={{ width: "100%", padding: "8px 20px" }}>
                            <ListItem
                                primaryText="My Profile"
                                leftIcon={<i className="fa fa-user" aria-hidden="true" style={{ fontSize: "24px", color: "#333" }}></i>}
                                onClick={this.handleProfile.bind(this)} />
                            <ListItem
                                primaryText="Share Funds "
                                leftIcon={<i className="fa fa-users" aria-hidden="true" style={{ fontSize: "24px", color: "#333" }}></i>}
                                onClick={this.handleFriends.bind(this)} />
                            <ListItem
                                primaryText="Manage My Alerts"
                                leftIcon={<i className="fa fa-bell" aria-hidden="true" style={{ fontSize: "24px", color: "#333" }}></i>}
                                onClick={this.handleAlerts.bind(this)} />
                            <ListItem
                                primaryText=" Setup Direct Entry"
                                leftIcon={<i className="fa fa-university" aria-hidden="true" style={{ fontSize: "24px", color: "#333" }}></i>}
                                onClick={this.handleLoadcard.bind(this)} />
                            {/* <ListItem
                                primaryText="Upgrade My Card"
                                leftIcon={<img src={creditcardlogo} alt="" />}
                                onClick={this.handleCards.bind(this)} /> */}
                            <ListItem
                                primaryText="Log Out"
                                leftIcon={<i className="fa fa-sign-out" aria-hidden="true" style={{ fontSize: "24px", color: "#333" }}></i>}
                                onClick={this.handleLogout.bind(this)} />
                        </List>
                        {/* </MobileTearSheet> */}
                    </div>
                </div>
            </div>
        );
    }
}
LeftLink.defaultProps = {
    profileState: {
        status: 400
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeftLink));


// WEBPACK FOOTER //
// ./src/components/leftlink/leftlink.jsx